import * as Yup from "yup";

export const initialValues = {
  speciesName: "",
};

export const getValidationSchema = () =>
  Yup.object().shape({
    speciesName: Yup.string().required("This field is required"),
  });
